import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProductVendor } from '../context/ProductVendorContext';

const VendorProductCardEditar = ({ product }) => {
  const navigate = useNavigate();
  const { editVendorProduct } = useProductVendor();

  const [price, setPrice] = useState(product.price);
  const [saving, setSaving] = useState(false);

  const handlePriceChange = (e) => {
    setPrice(e.target.value);
  };

  const handleSave = async () => {
    const parsedPrice = parseFloat(price);
    if (isNaN(parsedPrice) || parsedPrice < 0) {
      alert('Por favor ingresa un precio válido.');
      return;
    }

    setSaving(true);
    await editVendorProduct(product.id, {
      price: parsedPrice,
      Image: product.Image, // Required by backend
    });
    setSaving(false);

    alert('Precio actualizado correctamente.');
    navigate(-1); // Go back to previous page
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className="col mb-1">
      <div className="card h-100">
        <div
          className="badge bg-dark text-white position-absolute"
          style={{ top: '0.5rem', right: '0.5rem' }}
        >
          Stock: {product.Stock}
        </div>

        <img src={product.Image} alt={product.name} className="img-fluid d-block mx-auto" style={{ height: '300px', width: 'auto', objectFit: 'contain' }}/>

        <div className="card-body p-4 text-center">
          <h5 className="fw-bolder">{product.name}</h5>

          <div className="d-flex justify-content-center small text-warning mb-2">
            {Array.from({ length: product.Estrellas }).map((_, index) => (
              <i key={index} className="bi-star-fill star"></i>
            ))}
          </div>

          <div className="mt-3">
            <label htmlFor="priceInput" className="form-label">
              Precio (S/.)
            </label>
            <input
              id="priceInput"
              type="number"
              className="form-control"
              value={price}
              onChange={handlePriceChange}
              min="0"
              step="0.01"
              style={{ maxWidth: '200px', margin: '0 auto' }}
            />
          </div>
        </div>

        <div className="card-footer p-4 pt-0 border-top-0 bg-transparent text-center">
          <button
            className="btn btn-outline-success mt-auto me-2"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? 'Guardando...' : 'Guardar Cambios'}
          </button>
          <button
            className="btn btn-outline-secondary mt-auto"
            onClick={handleCancel}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default VendorProductCardEditar;
